import classnames from 'classnames';
import React from 'react';
import { Input, Label } from 'reactstrap';
import indeterminateIcon from '@/shared/ui/icons/Components/indeterminate-icon.svg';
import tintIndeterminateIcon from '@/shared/ui/icons/Components/tint-indeterminate-icon.svg';

export type CheckboxInputData = {
  label?: string;
  value?: string | number;
};

export type CheckboxInputProps = {
  className?: string;
  id: string;
  name?: string;
  data?: CheckboxInputData;
  checked?: boolean;
  isCheckAll?: boolean;
  disabled?: boolean;
  onChange?: (
    name: string | undefined,
    value: string | number | undefined,
    checked: boolean,
  ) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  isIndeterminate?: boolean;
  isSpecial?: boolean;
};

const CheckboxInput = ({
  className = '',
  id,
  name = '',
  data = {},
  checked = false,
  isCheckAll = false,
  disabled = false,
  isIndeterminate = false,
  isSpecial = false,
  onChange = () => {},
  onClick = () => {},
}: CheckboxInputProps) => {
  /**
   * Propagates a checkbox toggle to the parent form handler. Calls onChange with the input name, the bound data value and the new checked flag read from the DOM event.
   *
   * @param e - The checkbox change event carrying the new checked state.
   * @returns Nothing.
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(name, data.value, e.target.checked);
  };

  return (
    <div
      className={classnames('custom-checkbox-container', disabled ? '--disabled' : '', className)}
    >
      <Input
        type="checkbox"
        id={`custom-checkbox-input-${id}`}
        className={classnames(
          'custom-checkbox-input',
          isCheckAll ? '--check-all' : '',
          disabled ? '--disabled' : '',
          isIndeterminate ? 'indeterminate-input' : '',
          isSpecial ? 'special-input' : '',
          checked ? 'checked' : '',
        )}
        name={name}
        disabled={disabled}
        checked={checked}
        onChange={handleChange}
        onClick={onClick}
      />

      <Label
        htmlFor={`custom-checkbox-input-${id}`}
        style={disabled ? { pointerEvents: 'none' } : undefined}
      >
        {isIndeterminate && (
          <img
            className="indeterminate"
            src={isSpecial ? indeterminateIcon : tintIndeterminateIcon}
            alt="indeterminate-icon"
          />
        )}
        {!!data.label && <span className="custom-checkbox-label">{data.label}</span>}
      </Label>
    </div>
  );
};

export default CheckboxInput;
